import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiArrowUp} = FiIcons;

function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="footer-topline">
        <span aria-hidden="true" />
        <a className="back-top" href="#start">
          Zurück nach oben <SafeIcon icon={FiArrowUp} />
        </a>
      </div>
      <div className="footer-bottom">
        <img
          src="https://media-manager-c.questera.ai/greta-media/6a1fd9ec77a1b7736550a1122c15f1f27b12ad7af51d85a796d67feb48a26b8cef5743aa9bc766e63e43fa75e33ff1be/images/aW1hZ2UvcG5n/6738e5a1f9566ea3f10cd6566343d30c.png"
          alt="ALWAYS11"
          className="footer-agency-logo"
        />
        <p>Herzschlag Hamburg – Strategie &amp; Markenführung 2027.</p>
        <span>Mit Liebe in Hamburg gestaltet <i aria-hidden="true">♥</i></span>
      </div>
    </footer>
  );
}

export default SiteFooter;